<template>
  <div>
    <validation-observer v-slot={invalid}>
      <b-modal :ok-disabled="invalid" @ok="createMenu" id="add-menu" size="lg" title="Create Menu">
      <form action>
        <TextInput :rules="'required|MenuName'" placeholder="Menu Name" v-model="form.menu_name" />
        <TextInput :disabled="true" :rules="'required'" placeholder="Slug" v-model="form.slug" />
        <TextInput  placeholder="Description" v-model="form.description" />
        <FileUpload
          :onfile="fileChange"
          :value="file"
          :isLoading="fileLoading"
          @changed="fileChange($event)"
          label="upload background image"
          fileTypes="PNG up to 5MB"
          :progress="progress"
          :max="1"
          :deleteFile="deleteFile"
        />
      </form>
    </b-modal>
    </validation-observer>
    <Loader v-if="isFetchingMenu" />
    <div v-else class="mc-holder">
      <template v-for="(menu,index) in menus">
        <MenuCard :menu="menu" :key="index" />
      </template>
      <div @click="$bvModal.show('add-menu')" class="mc-wrapper add-menu">
        <div class="mc-content">
          <div class="mc-title">Add Menu</div>
          <BIconPlusCircle />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuCard from "./components/MenuCard";
import { BIconPlusCircle } from "bootstrap-vue";
import { firebase, auth } from "../Firebase/firebase";
import { Progress } from "@/components";
import FileUpload from "../pages/components/DragDropFileInput";
import Loader from "../pages/components/Loader";
import TextInput from "./components/Inputs/TextInput";
import {ValidationObserver} from "vee-validate"

export default {
  components: {
    MenuCard,
    BIconPlusCircle,
    [Progress.name]: Progress,
    FileUpload,
    Loader,
    TextInput,
    ValidationObserver
  },
  data() {
    return {
      form: {},
      file: [],
      formValues: "",
      fileLoading: false,
      isFetchingMenu: false
    };
  },
  methods: {
    fetchMenus() {
      this.isFetchingMenu = true;
      this.$store.dispatch("Menu/fetchMenus", auth).then(() => {
        this.isFetchingMenu = false;
      });
    },
    fileChange(file) {
      const formData = new FormData();
      formData.append("csvUpload", file);
      const formValues = formData;
      this.file = file;
    },
    createMenu(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$store
        .dispatch("Menu/createMenu", {
          file: this.file,
          form:this.form,
          userProfile: this.userProfile
        })
        .then(() => {
          this.$bvModal.hide("add-menu");
          this.$store.dispatch("Menu/resetUploads");
        });
    },
    deleteFile(index, item) {
      const tempFiles = [...this.file];
      tempFiles.splice(index, 1);
      this.file = [...tempFiles];
    }
  },
  computed: {
    progress() {
      return this.$store.state.Menu.uploadValue;
    },
    menus() {
      return this.$store.state.Menu.menus;
    },
    userProfile() {
      return this.$store.state.Auth.userProfile;
    }
  },
  watch:{
    'form.menu_name': function(){
      this.form.slug=this.form.menu_name.replace(/ /g,"").toLowerCase()
    }
  },
  mounted() {
    this.fetchMenus();
  }
};
</script>

<style>
.mc-holder {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 350px));
  grid-gap: 10px;
}

.add-menu {
  color: black;
  -webkit-box-shadow: -2px 2px 15px 0px rgba(0, 0, 0, 0.45);
  -moz-box-shadow: -2px 2px 15px 0px rgba(0, 0, 0, 0.45);
  box-shadow: -2px 2px 15px 0px rgba(0, 0, 0, 0.45);
}

.add-menu .mc-content {
  color: black;
}
</style>